var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { showApplicationLoader, hideApplicationLoader } from 'common/ApplicationLoader';
import { getCurrentSenior } from 'globals/global.functions';
import { openOverlayDialog, showError } from 'store/commonReducer/common.action';
import { showToast } from 'common/Toast';
import { DIALOG_TYPES } from 'globals/global.constants';
import { isEmpty } from 'lodash';
import { getAuditHistoryService, getPauseScheduleService, postPauseScheduleService, } from './PauseManagement.services';
import moment from 'moment';
import { derivePauseStatus, getPauseReasonLabel, } from './PauseManagement.types';
var isCompleted = function (entry) {
    return !!entry.pause_end_date;
};
var isScheduledEntry = function (entry) {
    return !entry.pause_start_date && !!entry.pause_end_date;
};
// NOTE: 'pause_now' must also be added to IPostPauseSchedulePayload['action_type']
// in PauseManagement.types.ts (e.g. 'paused' | 'unpaused' | 'cancelled' | 'pause_now'),
// along with an optional `is_confirmed?: boolean` field on that same interface.
var SUCCESS_TOAST_MESSAGE = {
    paused: 'Pause scheduled successfully.',
    unpaused: 'Unpaused successfully.',
    cancelled: 'Scheduled pause cancelled successfully.',
    pause_now: 'Paused immediately.',
};
var ACTION_TYPES_WITH_POSSIBLE_EMPTY_RESPONSE = ['paused', 'pause_now'];
var mapPauseSchedule = function (data) {
    var _a, _b;
    return ({
        actionLevel: data.action_level,
        actionType: data.action_type,
        pauseStartDate: data.pause_start_date
            ? moment(data.pause_start_date).format('MMM DD, YYYY hh:mm A')
            : '',
        pauseStartDateRaw: (_a = data.pause_start_date) !== null && _a !== void 0 ? _a : '',
        pauseEndDate: data.pause_end_date
            ? moment(data.pause_end_date).format('MMM DD, YYYY')
            : '',
        pauseEndDateRaw: (_b = data.pause_end_date) !== null && _b !== void 0 ? _b : '',
        pauseReason: getPauseReasonLabel(data.reason_code),
        pauseEpochDate: data.next_action_epoch
            ? moment(data.next_action_epoch).format('MMM DD, YYYY hh:mm A')
            : '',
        updatedByName: data.name,
        updatedById: data.updated_by,
        scheduleStatus: data.schedule_status,
    });
};
var mapAuditEntry = function (entry) {
    var _a, _b;
    return ({
        recordedAt: entry.audit_recorded_timestamp,
        recordedAtFormatted: entry.audit_recorded_timestamp
            ? moment(entry.audit_recorded_timestamp).format('MMM DD, YYYY hh:mm A')
            : '',
        actionLevel: entry.action_level,
        pauseReason: getPauseReasonLabel(entry.reason_code),
        pauseStartDate: entry.pause_start_date
            ? moment(entry.pause_start_date).format('MMM DD, YYYY hh:mm A')
            : '—',
        pauseStartDateRaw: (_a = entry.pause_start_date) !== null && _a !== void 0 ? _a : '',
        pauseEndDate: entry.pause_end_date
            ? moment(entry.pause_end_date).format('MMM DD, YYYY hh:mm A')
            : '—',
        pauseEndDateRaw: (_b = entry.pause_end_date) !== null && _b !== void 0 ? _b : '',
        updatedBy: entry.updated_by,
    });
};
var mapAuditHistory = function (data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var history = (_a = data.audit_history) === null || _a === void 0 ? void 0 : _a.filter(isCompleted).map(mapAuditEntry);
    var latestScheduled = {};
    ['profile', 'device', 'notification'].forEach(function (level) {
        var _a;
        var entry = (_a = data.audit_history) === null || _a === void 0 ? void 0 : _a.find(function (e) { return e.action_level === level && isScheduledEntry(e); });
        if (entry)
            latestScheduled[level] = mapAuditEntry(entry);
    });
    return {
        seniorId: data.senior_id,
        rawFlags: {
            profile: data.profile,
            device: data.device,
            notification: data.notification,
        },
        // NOTE: pauseStatus is the *display-facing* derived value and must cascade
        // (profile paused ⇒ device + notification also read as paused, and
        // device paused ⇒ notification also reads as paused). rawFlags above is
        // intentionally left un-cascaded since other logic (e.g. deriveDevicePauseRange)
        // needs the actual individual toggle state.
        pauseStatus: derivePauseStatus((_b = data.profile) !== null && _b !== void 0 ? _b : false, (_c = data.device) !== null && _c !== void 0 ? _c : false, (_d = data.notification) !== null && _d !== void 0 ? _d : false),
        scheduledStatus: {
            profile: (_e = data.is_profile_schedule) !== null && _e !== void 0 ? _e : false,
            device: (_f = data.is_device_schedule) !== null && _f !== void 0 ? _f : false,
            notification: (_g = data.is_notification_schedule) !== null && _g !== void 0 ? _g : false,
        },
        scheduleDates: {
            profile: (_h = data.profile_schedule_date) !== null && _h !== void 0 ? _h : '',
            device: (_j = data.device_schedule_date) !== null && _j !== void 0 ? _j : '',
            notification: (_k = data.notification_schedule_date) !== null && _k !== void 0 ? _k : '',
        },
        profileActualPausedDate: (_l = data.profile_actual_paused_date) !== null && _l !== void 0 ? _l : '', // ← added
        deviceActualPausedDate: (_m = data.device_actual_paused_date) !== null && _m !== void 0 ? _m : '',
        totalCount: history === null || history === void 0 ? void 0 : history.length,
        history: history,
        profileHistory: history === null || history === void 0 ? void 0 : history.filter(function (r) { return r.actionLevel === 'profile'; }),
        deviceHistory: history === null || history === void 0 ? void 0 : history.filter(function (r) { return r.actionLevel === 'device'; }),
        notificationHistory: history === null || history === void 0 ? void 0 : history.filter(function (r) { return r.actionLevel === 'notification'; }),
        latestScheduled: latestScheduled,
    };
};
export var getPauseSchedule = function () { return function (dispatch) { return __awaiter(void 0, void 0, Promise, function () {
    var senior_id, response, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                senior_id = getCurrentSenior().senior_id;
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                dispatch(showApplicationLoader());
                return [4 /*yield*/, getPauseScheduleService({ senior_id: senior_id })];
            case 2:
                response = _a.sent();
                dispatch(hideApplicationLoader());
                if (response.error || !response.data)
                    return [2 /*return*/, null];
                return [2 /*return*/, mapPauseSchedule(response.data)];
            case 3:
                error_1 = _a.sent();
                dispatch(hideApplicationLoader());
                dispatch(showError(error_1));
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var getAuditHistory = function (seniorId) { return function (dispatch) { return __awaiter(void 0, void 0, Promise, function () {
    var senior_id, response, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                senior_id = getCurrentSenior().senior_id;
                if (seniorId) {
                    senior_id = seniorId;
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                dispatch(showApplicationLoader());
                return [4 /*yield*/, getAuditHistoryService({ senior_id: senior_id })];
            case 2:
                response = _a.sent();
                dispatch(hideApplicationLoader());
                if (response.error || !response.data)
                    return [2 /*return*/, null];
                return [2 /*return*/, mapAuditHistory(response.data)];
            case 3:
                error_2 = _a.sent();
                dispatch(hideApplicationLoader());
                dispatch(showError(error_2));
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var postPauseSchedule = function (payload) {
    return function (dispatch) { return __awaiter(void 0, void 0, Promise, function () {
        var response, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    dispatch(showApplicationLoader());
                    return [4 /*yield*/, postPauseScheduleService(payload)];
                case 1:
                    response = _b.sent();
                    dispatch(hideApplicationLoader());
                    if (response.error) {
                        dispatch(showError(response.message));
                        return [2 /*return*/, null];
                    }
                    if (ACTION_TYPES_WITH_POSSIBLE_EMPTY_RESPONSE.includes(payload.action_type)
                        && isEmpty(response.data)) {
                        dispatch(openOverlayDialog({
                            type: DIALOG_TYPES.DISPLAY_MESSAGE,
                            firstMessage: response.message,
                        }));
                        return [2 /*return*/, null];
                    }
                    dispatch(showToast((_a = SUCCESS_TOAST_MESSAGE[payload.action_type]) !== null && _a !== void 0 ? _a : 'Action completed successfully.', 'success'));
                    return [2 /*return*/, response];
                case 2:
                    error_3 = _b.sent();
                    dispatch(hideApplicationLoader());
                    dispatch(showError(error_3));
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
